import NotificationComponent from "@components/NotificationComponent";
import { initialData } from "@assets/demmyData/demmyData";

function Notification() {
  return <NotificationComponent data={initialData} heading="notification" />;
}

export default Notification;
